import React from 'react';
import { Grid2, Typography } from '@mui/material';
import { formatDate } from './formatDate';
import { paymentFacts } from './contractPaymentFacts';

function principalText(facts) {
  if (facts.hidePrincipal) return 'ติดต่อบริษัท';
  if (facts.remainingPrincipal == null) return '—';
  return null;
}

function NextPaymentDate({ facts }) {
  return (
    <>
      <Typography variant="caption" color="textSecondary">
        ชำระครั้งถัดไป
      </Typography>
      <Typography variant="body1" color="secondary">
        {facts.nextPaymentDate ? formatDate(facts.nextPaymentDate) : '—'}
      </Typography>
    </>
  );
}

function RemainingPrincipal({ facts, hiddenOrEmpty }) {
  return (
    <>
      <Typography variant="caption" color="textSecondary">
        เงินต้นคงเหลือ
      </Typography>
      {hiddenOrEmpty ? (
        <Typography variant="body1" color="primary">
          {hiddenOrEmpty}
        </Typography>
      ) : (
        <div flexitem="true">
          <Typography
            variant="h6"
            color="secondary"
            sx={{ display: 'inline-block' }}
          >
            {facts.remainingPrincipal.toLocaleString()}
          </Typography>
          <Typography variant="caption" sx={{ marginLeft: 1 }}>
            บาท
          </Typography>
        </div>
      )}
    </>
  );
}

const PaymentFacts = ({ contract, columns = false }) => {
  const facts = paymentFacts(contract);
  const hiddenOrEmpty = principalText(facts);

  if (columns) {
    return (
      <>
        <Grid2 size={6}>
          <NextPaymentDate facts={facts} />
        </Grid2>
        <Grid2 size={6}>
          <RemainingPrincipal facts={facts} hiddenOrEmpty={hiddenOrEmpty} />
        </Grid2>
      </>
    );
  }

  return (
    <>
      <NextPaymentDate facts={facts} />
      <Typography component="div" sx={{ mt: 1 }}>
        <RemainingPrincipal facts={facts} hiddenOrEmpty={hiddenOrEmpty} />
      </Typography>
    </>
  );
};

export default PaymentFacts;
